import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ErrorStateMatcher } from '@angular/material';
import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { LoginService } from '../service/login.service';
import { MessageService } from '../service/message.service';

export class MyErrorStateMatcher implements ErrorStateMatcher {
	isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
		const isSubmitted = form && form.submitted;
		return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
	}
}

@Component({
	selector: 'lib-user-tenant',
	templateUrl: './tenant.component.html',
	styleUrls: ['./tenant.component.scss']
})
export class UserTenantComponent implements OnInit {

	tenants: any[];
	selectedTenant: any;
	matcher = new MyErrorStateMatcher();

	@Input() selectedTenantId: string;
	@Input() readonly = false;
	@Input() endPoint: string;
	
	@Output() tenantSelected = new EventEmitter<any>();

	constructor(
		private loginService: LoginService,
		private messageService: MessageService,
	) {
	}

	ngOnInit() {
		this.query(this.loginService.getLoginId()).subscribe((tenants: any[]) => {
			this.tenants = tenants.filter((tenant: any) => tenant.activeState === 'Active').map((tenant: any) => {
				if (tenant.quotaProperties.QuotaCpu) {
					tenant.quotaProperties.QuotaCpu.reserved = Number(tenant.quotaProperties.QuotaCpu.reserved.toFixed(0));
				}
				if (tenant.quotaProperties.QuotaMemory) {
					tenant.quotaProperties.QuotaMemory.reserved = Number(tenant.quotaProperties.QuotaMemory.reserved.toFixed(0));
				}
				if (tenant.quotaProperties.QuotaDisk) {
					tenant.quotaProperties.QuotaDisk.reserved = Number(tenant.quotaProperties.QuotaDisk.reserved.toFixed(0));
				}

				return tenant;
			});

			if (this.selectedTenantId) {
				this.tenants.forEach((tenant: any) => {
					if (tenant.id === this.selectedTenantId) {
						this.selectedTenant = tenant;
						this.onTenantChanged(tenant);
					}
				})
			} else {
				if (this.tenants.length > 0) {
					const userTenants = this.tenants.filter((tenant: any) => tenant.type === 'User');
					if (userTenants.length > 0) {
						this.selectedTenant = this.tenants[0];
						this.onTenantChanged(this.selectedTenant);
					} else {
						console.log("There is no user tenant in user(" + this.loginService.getLoginId() + ") !!!");
					}
				}
			}
		});
	}

	query(id: string): Observable<any[]> {
		const subject = new Subject<any[]>();
		// const url = this.endPoint + '/' + id + '/tenant/';
		const url = this.endPoint;

		const subscription = this.messageService.query(url).subscribe((tenants: any[]) => {
			const ownerTenants = tenants.filter((tenant: any) => tenant.name === 'default');
			const subTenants = tenants.filter((tenant: any) => tenant.name !== 'default');

			subTenants.sort((a, b) => {
				return a.name.localeCompare(b.name);
			});
			tenants = ownerTenants.concat(subTenants);
			tenants.forEach((tenant: any) => {
				if (tenant.quotaProperties.QuotaCpu) {
					tenant.quotaProperties.QuotaCpu.available = tenant.quotaProperties.QuotaCpu.total - tenant.quotaProperties.QuotaCpu.reserved;
				}
				if (tenant.quotaProperties.QuotaMemory) {
					tenant.quotaProperties.QuotaMemory.available = tenant.quotaProperties.QuotaMemory.total - tenant.quotaProperties.QuotaMemory.reserved;
				}
				if (tenant.quotaProperties.QuotaDisk) {
					tenant.quotaProperties.QuotaDisk.available = tenant.quotaProperties.QuotaDisk.total - tenant.quotaProperties.QuotaDisk.reserved;
				}
				if (tenant.quotaProperties.QuotaGpu) {
					tenant.quotaProperties.QuotaGpu.available = tenant.quotaProperties.QuotaGpu.total - tenant.quotaProperties.QuotaGpu.reserved;	
				}
			});
			subject.next(tenants);
			subscription.unsubscribe();
		}, (error: any) => {
			subject.error(error);
			subscription.unsubscribe();
		});

		return subject;
	}

	onTenantChanged(_: any) {
		this.tenantSelected.emit(this.selectedTenant);
	}

}
